export const conf = {
    translationServiceUrl: import.meta.env.VITE_TRANSLATION_SERVICE_URL,
    translationServiceProjectId: import.meta.env.VITE_TRANSLATION_SERVICE_PROJECT_ID,
    defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE,
    publicPath: import.meta.env.VITE_PUBLIC_PATH,
    assetServiceUrl: import.meta.env.VITE_ASSET_SERVICE_URL
};